import React from 'react';
import ReactGA4 from 'react-ga4';
import { Col, Row } from 'reactstrap';

import creightonImage from '../../../assets/img/brand/Creighton.jpg';
import lynnImage from '../../../assets/img/brand/Lynn.jpg';
import militaryImg from '../../../assets/img/brand/milcom-logo.png';
import umassGlobalImage from '../../../assets/img/brand/UMASS-Global.jpg';
import wakeForestImage from '../../../assets/img/brand/Wake-Forest.jpg';
import { DashboardDesktop, DashboardMobile } from '../../Common/const';

const MILITARY = 'Military.com';
const UMASS = 'UMass Global';
const CREIGHTON = 'Creighton Univ.';
const WAKE_FOREST = 'Wake Forest Univ.';
const LYNN = 'Lynn University';
const MYNAVIHR = 'Mynavihr';

const links = {
  [UMASS]:
    'https://onlinedegrees.umassglobal.edu/military?source=SC00124&ve=62745&utm_source=bluejacketeer.com&utm_medium=referral&utm_campaign=bluejacketeer_to_msp_military&utm_content=military',
  [CREIGHTON]:
    'https://www.creighton.edu/cost-aid/types-aid/military-veterans-benefits/military-tuition-discounts?source=SC00124&ve=62745&utm_source=bluejacketeer.com&utm_medium=referral&utm_campaign=bluejacketeer_to_msp_military&utm_content=military_tuition_discounts',
  [WAKE_FOREST]:
    'https://financialaid.wfu.edu/resources/veterans-education-benefits/',
  [LYNN]:
    'https://online.lynn.edu/?source=SC00124&ve=62745&utm_source=bluejacketeer.com&utm_medium=referral&utm_campaign=bluejacketeer_to_msp_military&utm_content=homepage',
  // broken:
  [MYNAVIHR]:
    // General: 'https://www.mynavyhr.navy.mil/References/BUPERS-Instructions/',
    'https://www.mynavyhr.navy.mil/Portals/55/Reference/Instructions/BUPERS/BUPERSINST%201430.16.pdf?ver=11P7X09h2Dm3s3RmSrCWyQ%3d%3d',
};

class EducationCenterView extends React.Component {
  handleLinkClick = (name) => {
    // Google Analytics 4
    ReactGA4.event({
      category: 'Select',
      action: `External link Click (${name})`,
      label: `External link Click (${name})`,
    });
  };

  render() {
    return (
      <div className="col-xs-12">
        <DashboardMobile>
          <Row className="m-0">
            <Col xs={12} className="pt-3">
              <center>
                <a
                  onClick={() => this.handleLinkClick(MILITARY)}
                  href={links[MILITARY]}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="mb-4 mt-4 img-fluid w-100 pl-4 pr-4"
                    alt="education-center mobile"
                    src={militaryImg}
                    loading="lazy"
                    height="100"
                    width="382"
                  />
                </a>
              </center>
            </Col>
            <Col xs={12} className="mt-5 mb-4 education-center-content-mobile">
              <h3 className="mx-3 mb-2">
                <strong>
                  We can help you get your associate’s degree FAST! For HMs and
                  MAs, it can be in as few as five classes! After that, we can
                  help you earn your bachelor’s degree fast, too!. (Varies based
                  on your AFSC). This helps with your Air Force Advancement, or
                  your post-Air Force career.
                </strong>
              </h3>
              <hr className="education-center-separator" />
              <h3 className="mx-3 mb-2">Need help studying for other exams?</h3>
              <p className="mx-3 mb-2">
                Kaplan proudly supports military students in their lifelong
                learning and career development. The VA has approved a number of
                Kaplan exam prep courses and private tutoring for reimbursement,
                including the GMAT™, LSAT®, NCLEX-RN®, NCLEX-PN®, MCAT®,
                GRE®, Bar Review, and SAT®. See{' '}
                <a
                  href="https://promotionwingman-prod.nyc3.cdn.digitaloceanspaces.com/42946_KNA_MIL_Kaplan_VA_Flyer_FINAL_250530.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  this flyer
                </a>{' '}
                for more information.
              </p>
              <h3 className="mx-3 mb-2">
                What about other, smaller career ready examinations?
              </h3>
              <p className="mx-3 mb-2">
                Prepare with confidence using Kaplan{' '}
                <a
                  href="https://certprep.kaptest.com/?utm_source=bluejacketeer&utm_medium=referral&utm_campaign=affiliate"
                  target="_blank"
                  rel="noreferrer"
                >
                  <strong>
                    <u>CertPrep</u>
                  </strong>
                </a>
                ! Our targeted Qbanks deliver hundreds of exam-style questions
                to help you master key concepts, sharpen test-taking skills, and
                pass your certification exam. Accessible, affordable, and built
                for real-world readiness,{' '}
                <a
                  href="https://certprep.kaptest.com/?utm_source=bluejacketeer&utm_medium=referral&utm_campaign=affiliate"
                  target="_blank"
                  rel="noreferrer"
                >
                  <strong>
                    <u>CertPrep</u>
                  </strong>
                </a>{' '}
                is the smarter way to study for certifications like CDL,
                SHRM-CP, EPA 608, and more. Start today and take the next step
                in your career!
              </p>
              <h3 className="mx-3 mb-2">
                <strong>The value of education towards your advancement</strong>
              </h3>
              <p className="mx-3 mb-2">
                At Promotion Wingman, we take your career and your advancement
                seriously. There are a variety of factors inside and outside of
                your control that make up your overall potential to advance in
                the Air Force. Quotas, Time in Grade, Exam Performance, Awards,
                Evals, PNA points, and Education all play into your overall
                Final Multiple Score (FMS).
              </p>
              <p className="mx-3 mb-2">
                You came to Promotion Wingman to help with your Advancement Exam
                score, but we can also help you with your education!
              </p>
              <div className="mx-3 p-0 border-shadow rounded mb-3">
                <Row className="justify-content-center no-gutters gray-border rounded-top titleEducation">
                  <h4 className="text-uppercase m-0 p-2">
                    <strong>Education programs</strong>
                  </h4>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0 rounded-bottom flex-column-reverse flex-lg-row">
                  <Col xs={12} lg={9} className="py-2 border-right">
                    Earn Your MBA or Master’s in Organizational Leadership in
                    Only 7 Courses! Find a clear pathway to earning your
                    master’s degree so you can take your career in the direction
                    you want. Educating members of the military is at the root
                    of who we are. It’s how we got started more than 65 years
                    ago — providing outreach education to Marines stationed at
                    Marine Corps Air Station El Toro — and our dedication to
                    supporting U.S. service members, veterans, and their
                    families has grown ever since. <br />
                    <i>TA/G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={12} lg={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(UMASS)}
                      href={links[UMASS]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={umassGlobalImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0 flex-column-reverse flex-lg-row">
                  <Col xs={12} lg={9} className="py-2 border-right">
                    More than an education, Creighton University offers master’s
                    degrees and graduate certificates rooted in values for those
                    who believe in building a better future for the world. With
                    program options in business, finance, leadership and more,
                    eligible active military can receive a 30% tuition discount
                    toward eligible programs.
                    <br />
                    <i>G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={12} lg={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(CREIGHTON)}
                      href={links[CREIGHTON]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={creightonImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0 flex-column-reverse flex-lg-row">
                  <Col xs={12} lg={9} className="py-2 border-right">
                    Designed for working professionals and driven by market
                    needs, Wake Forest offers flexible, online master’s and
                    graduate certificate degree options. Gain the in-demand
                    skills to take the next step in your career as a leader with
                    programs in business, project management, marketing and
                    communications, healthcare, education and more. <br />
                    <i>G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={12} lg={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(WAKE_FOREST)}
                      href={links[WAKE_FOREST]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={wakeForestImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0 flex-column-reverse flex-lg-row">
                  <Col xs={12} lg={9} className="py-2 border-right">
                    Lynn University provides online bachelor’s programs,
                    including Aviation Management, Healthcare Management,
                    Criminal Justice, Business and more to help you advance your
                    career. With three start dates per year, and online programs
                    to help you balance work and family life, Lynn provides the
                    opportunity to be boundless! <br />
                    <i>TA/G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={12} lg={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(LYNN)}
                      href={links[LYNN]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={lynnImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </DashboardMobile>

        <DashboardDesktop>
          <Row className="m-0">
            {/* main content */}
            <Col xs={8} className="education-center-content-desktop pt-0">
              <h3 className="ml-3 mb-2">
                <strong>
                  We can help you get your associate’s degree FAST! For HMs and
                  MAs, it can be in as few as five classes! After that, we can
                  help you earn your bachelor’s degree fast, too!. (Varies based
                  on your AFSC). This helps with your Air Force Advancement, or
                  your post-Air Force career.
                </strong>
              </h3>
              <hr className="education-center-separator" />
              <h3 className="ml-3 mb-2">Need help studying for other exams?</h3>
              <p className="ml-3 mb-2">
                Kaplan proudly supports military students in their lifelong
                learning and career development. The VA has approved a number of
                Kaplan exam prep courses and private tutoring for reimbursement,
                including the GMAT™, LSAT®, NCLEX-RN®, NCLEX-PN®, MCAT®,
                GRE®, Bar Review, and SAT®. See{' '}
                <a
                  href="https://promotionwingman-prod.nyc3.cdn.digitaloceanspaces.com/42946_KNA_MIL_Kaplan_VA_Flyer_FINAL_250530.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  this flyer
                </a>{' '}
                for more information.
              </p>
              <h3 className="ml-3 mb-2">
                What about other, smaller career ready examinations?
              </h3>
              <p className="ml-3 mb-2">
                Prepare with confidence using Kaplan{' '}
                <a
                  href="https://certprep.kaptest.com/?utm_source=bluejacketeer&utm_medium=referral&utm_campaign=affiliate"
                  target="_blank"
                  rel="noreferrer"
                >
                  <strong>
                    <u>CertPrep</u>
                  </strong>
                </a>
                ! Our targeted Qbanks deliver hundreds of exam-style questions
                to help you master key concepts, sharpen test-taking skills, and
                pass your certification exam. Accessible, affordable, and built
                for real-world readiness,{' '}
                <a
                  href="https://certprep.kaptest.com/?utm_source=bluejacketeer&utm_medium=referral&utm_campaign=affiliate"
                  target="_blank"
                  rel="noreferrer"
                >
                  <strong>
                    <u>CertPrep</u>
                  </strong>
                </a>{' '}
                is the smarter way to study for certifications like CDL,
                SHRM-CP, EPA 608, and more. Start today and take the next step
                in your career!
              </p>
              <h3 className="ml-3 mb-2">
                <strong>The value of education towards your advancement</strong>
              </h3>
              <p className="ml-3 mb-2">
                At Promotion Wingman, we take your career and your advancement
                seriously. There are a variety of factors inside and outside of
                your control that make up your overall potential to advance in
                the Air Force. Quotas, Time in Grade, Exam Performance, Awards,
                Evals, PNA points, and Education all play into your overall
                Final Multiple Score (FMS).
              </p>
              <p className="ml-3 mb-2">
                You came to Promotion Wingman to help with your Advancement Exam
                score, but we can also help you with your education!
              </p>
              <div className="ml-3 p-0 border-shadow rounded mb-5">
                <Row className="justify-content-center no-gutters gray-border rounded-top titleEducation">
                  <h4 className="text-uppercase m-0 p-2">
                    <strong>Education programs</strong>
                  </h4>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0 rounded-bottom">
                  <Col xs={9} className="py-2 border-right">
                    Earn Your MBA or Master’s in Organizational Leadership in
                    Only 7 Courses! Find a clear pathway to earning your
                    master’s degree so you can take your career in the direction
                    you want. Educating members of the military is at the root
                    of who we are. It’s how we got started more than 65 years
                    ago - providing outreach education to Marines stationed at
                    Marine Corps Air Station El Toro - and our dedication to
                    supporting U.S. service members, veterans, and their
                    families has grown ever since.
                    <br /> <i>TA/G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(UMASS)}
                      href={links[UMASS]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={umassGlobalImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0">
                  <Col xs={9} className="py-2 border-right">
                    More than an education, Creighton University offers master’s
                    degrees and graduate certificates rooted in values for those
                    who believe in building a better future for the world. With
                    program options in business, finance, leadership and more,
                    eligible active military can receive a 30% tuition discount
                    toward eligible programs.
                    <br /> <i>G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(CREIGHTON)}
                      href={links[CREIGHTON]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={creightonImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0">
                  <Col xs={9} className="py-2 border-right">
                    Designed for working professionals and driven by market
                    needs, Wake Forest offers flexible, online master’s and
                    graduate certificate degree options. Gain the in-demand
                    skills to take the next step in your career as a leader with
                    programs in business, project management, marketing and
                    communications, healthcare, education and more.
                    <br /> <i>G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(WAKE_FOREST)}
                      href={links[WAKE_FOREST]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={wakeForestImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
                <Row className="justify-content-center m-0 gray-border border-top-0">
                  <Col xs={9} className="py-2 border-right">
                    Lynn University provides online bachelor’s programs,
                    including Aviation Management, Healthcare Management,
                    Criminal Justice, Business and more to help you advance your
                    career. With three start dates per year, and online programs
                    to help you balance work and family life, Lynn provides the
                    opportunity to be boundless! <br />
                    <i>TA/G.I. Bill eligible.</i>
                  </Col>
                  <Col xs={3} className="image-education-programs">
                    <a
                      onClick={() => this.handleLinkClick(LYNN)}
                      href={links[LYNN]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="img-fluid"
                        alt="education-center"
                        src={lynnImage}
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* Sidebar content */}
            <Col xs="4">
              <Row className="m-0 border rounded shadow-lg">
                <Col xs={12}>
                  <center>
                    <a
                      onClick={() => this.handleLinkClick(MILITARY)}
                      href={links[MILITARY]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        height="131.14"
                        width="437.66"
                        className="mb-4 mt-4 img-fluid"
                        alt="education-center desktop"
                        src={militaryImg}
                        loading="lazy"
                      />
                    </a>
                  </center>
                </Col>
              </Row>
            </Col>
          </Row>
        </DashboardDesktop>
      </div>
    );
  }
}

export default EducationCenterView;
